import React, {useEffect, useState} from 'react'
import {Box, Skeleton, Link} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCustomer, useCustomerId, useCustomerType} from '@salesforce/commerce-sdk-react'
import {FormattedMessage} from 'react-intl'
import ContentAsset from '../content-asset'
import {KS_CREATE_ACCOUNT_URL, KS_LOGIN_URL} from '../../constants'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useLoyaltyCalloutsConfigs from '../../hooks/use-loyalty-callouts-configs'
import {useSiteContext} from '../../contexts/site'

const LoyaltyCallouts = () => {
    const customerId = useCustomerId()
    const {isYR} = useSiteContext()
    const {isRegistered} = useCustomerType()
    const {data: customer} = useCustomer({parameters: {customerId}})
    const {
        app: {commerceAPI}
    } = getConfig()
    const {hostUrl} = commerceAPI.storefront
    const [isAwardActive, setIsAwardActive] = useState(false)

    const {data: loyaltyCalloutsData} = useLoyaltyCalloutsConfigs(isRegistered, isYR)

    useEffect(() => {
        if (customer?.c_BACouponExpirationDate) {
            var dateNow = new Date()
            var BAExpirationDate = new Date(customer.c_BACouponExpirationDate)
            setIsAwardActive(dateNow < BAExpirationDate)
        }
    }, [isRegistered])

    return loyaltyCalloutsData ? (
        <Box className="loyalty-callouts-wrapper">
            <Box margin="30px 1rem 20px 1rem">
                {loyaltyCalloutsData?.showLoyaltySignInOrUpMessage &&
                    loyaltyCalloutsData?.loyaltySignInOrUpMessage && (
                        <Box
                            dangerouslySetInnerHTML={{
                                __html: loyaltyCalloutsData?.loyaltySignInOrUpMessage
                            }}
                        />
                    )}
            </Box>
            {loyaltyCalloutsData?.showSignUpSigninButtons && (
                <Box width="fit-content">
                    <Link
                        href={hostUrl + KS_CREATE_ACCOUNT_URL}
                        backgroundColor="gray.450"
                        color="black.100"
                        borderRadius="90px"
                        padding="0.5rem 1.5rem"
                        margin="1rem"
                        fontSize="14px"
                        _hover={{textDecoration: 'none'}}
                        textDecoration="none"
                    >
                        <FormattedMessage id="sign.up" defaultMessage="Sign Up" />
                    </Link>
                    <Link
                        href={hostUrl + KS_LOGIN_URL}
                        backgroundColor="transparent"
                        color="black.100"
                        borderColor="gray.800"
                        border="1px solid"
                        borderRadius="90px"
                        fontSize="14px"
                        padding="0.5rem 1.5rem"
                        _hover={{textDecoration: 'none'}}
                        textDecoration="none"
                    >
                        <FormattedMessage id="sign.in" defaultMessage="Sign In" />
                    </Link>
                </Box>
            )}

            {isRegistered &&
                isAwardActive &&
                customer.c_BA50Redeemable &&
                loyaltyCalloutsData?.loyalty25and50offMessage && (
                    <Box
                        className="birthday-promo-50"
                        margin="2rem 1rem"
                        dangerouslySetInnerHTML={{
                            __html: loyaltyCalloutsData?.loyalty25and50offMessage
                        }}
                    />
                )}
            {isRegistered &&
                isAwardActive &&
                customer.c_BA25Redeemable &&
                loyaltyCalloutsData?.BA50Redeemable && (
                    <Box
                        className="birthday-promo-25"
                        margin="2rem 1rem"
                        dangerouslySetInnerHTML={{__html: loyaltyCalloutsData?.BA50Redeemable}}
                    />
                )}
            {loyaltyCalloutsData?.loyaltyContentAssetCalloutEnabled && (
                <ContentAsset contentAssetId="loyalty-callout" />
            )}
        </Box>
    ) : (
        <Skeleton height="80px" width="40%" margin="1rem" />
    )
}
export default LoyaltyCallouts
